// Compact horizontal brand mark for the dashboard header.
// Eye PNG on the left, "mEYEcam" wordmark stylised with cyan "EYE" infix.
import React from "react";

export default function HostHeaderLogo({ size = 44 }) {
  return (
    <div className="flex items-center gap-3 select-none" data-testid="host-brand">
      <img
        src="/meyecam-logo.png"
        alt="mEYEcam"
        draggable={false}
        style={{ width: size, height: size, objectFit: "contain" }}
      />
      <div className="leading-none">
        <div className="text-2xl sm:text-3xl font-bold tracking-tight">
          <span style={{ color: "#fff" }}>m</span>
          <span style={{ color: "#22E2FF" }}>EYE</span>
          <span style={{ color: "#fff" }}>cam</span>
        </div>
      </div>
    </div>
  );
}
